import {getTabulaIni} from '../../constants/metaData';

export const openVscodeDeeplink = (path: string) => {
    const deeplink = buildVscodeDeeplink(path);
    window.open(deeplink, '_blank');
};

const buildVscodeDeeplink = (path: string) => {
    const vscodeBaseUrl = 'vscode://prioritysoftware.priority-vscode/openFile?oDataUrl=';

    const baseUrl = window.origin;
    //tabula.ini

    const odataUrl = baseUrl + '/odata';
    const tabulaIni = getTabulaIni();
    const deeplink = `${vscodeBaseUrl}${odataUrl}&tabulaini=${tabulaIni}&path=${path}`;

    return deeplink;
};
